export const k = {
    ikkeLoggetInd: "domains.authentication.components.login-gate.login-gate-i18n.ikkeLoggetInd",
    loginSpinnerText: "domains.authentication.components.login-gate.login-gate-i18n.loginSpinnerText"
};
export const translations = {
    da: {
        ikkeLoggetInd: "Du er ikke logget ind.",
        loginSpinnerText: "Logger ind..."
    },
    en: {
        ikkeLoggetInd: "You are not signed in.",
        loginSpinnerText: "Signing in..."
    }
};
